import LP from '../0-lp';
import $ from 'jquery';

LP.pollSettingsPage = {
    init: function (mode) {
        LP.pollSettingsPage.switchMode(mode);

        $('#notanonym').click(function () {
            $('#anonymouswarning').show();
        });
        $('#anonym').click(function () {
            $('#anonymouswarning').hide();
        });

        $('#iframeallowed').click(function () {
            $('.allowiframefrom').show();
        });
        $('#iframenotallowed').click(function () {
            $('.allowiframefrom').hide().find('textarea').val('');
            LP.pollSettingsPage.saveSettings();
        });

        $('#lp-pollsettings-page .iframemode').click(function () {
            $('.code-with-resize').hide();
            $('.code-fixed-size').hide();
            $('.code-as-popup').hide();
            $('.code-with-embedd').hide();

            var mode = $(this).val();

            if (mode == 'r') {
                $('.code-with-resize').show();
            }
            if (mode == 'f') {
                $('.code-fixed-size').show();
            }
            if (mode == 'p') {
                $('.code-as-popup').show();
            }
            if (mode == 's') {
                $('.code-with-embedd').show();
            }
        });

        $('#lp-pollsettings-page input:not([name="pollGen[pass]"]):not([name="pollGen[allowiframe]"])').change(LP.pollSettingsPage.saveSettings); // trigger change event at last
        $('#lp-pollsettings-page textarea').change(LP.pollSettingsPage.saveSettings); // trigger change event at last
    },

    switchMode: function (mode) {
        $('.lp-settings-view').hide();
        var view = $('#settings-' + mode);
        view.show();
    },

    selectTab: function (tab) {
        $('.poll-menu .sublink').removeClass('active');
        tab.addClass('active');

        $('.lp-settings-view').hide();
        var view = $('#' + tab.attr('view'));
        view.show();
        return false;
    },

    saveSettings: function () {
        var form = $('#lp-pollsettings-form');
        var url = form.attr('action');
        var data = form.serialize();

        window.Browser.send(url, data, LP.pollSettingsPage.settingsSaved, LP.pollSettingsPage.settingsNotSaved);
    },

    settingsSaved: function (json) {
        if (json.iframeURIs) {
            $('#lp-iframeform').val(json.iframeURIs);
        }
        $('[name="pollPart[allowedIPs]"]').removeClass('error');
        $('[name="pollPart[deniedIPs]"]').removeClass('error');
    },

    settingsNotSaved: function (json) {
        if (json.allowedIPs) {
            $('[name="pollPart[allowedIPs]"]').addClass('error');
        }
        if (json.deniedIPs) {
            $('[name="pollPart[deniedIPs]"]').addClass('error');
        }
    }
};